import {useMemo} from "react";

const useFilter = ({documents, filter}) => useMemo(
    () => documents && filter ? documents.filter((item) => {
        return filter === 'NOTLISTED' ? item.group === null : item.group === filter;
    }) : documents,
    [documents, filter]
);

export default useFilter;